import { useEffect } from 'react';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import IntroductionSection from './components/IntroductionSection';
import CuisineSection from './components/CuisineSection';
import CampSection from './components/CampSection';
import SkiRentalSection from './components/SkiRentalSection';
import PricingSection from './components/PricingSection';
import AccessSection from './components/AccessSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function HomePage() {
  // Schema.org for LodgingBusiness
  useSchemaOrg({
    type: 'LodgingBusiness',
    data: {
      description: 'ハチ高原の自然に寄り添い、森に包まれるやすらぎの時間をお過ごしいただける和風民宿です。',
      starRating: {
        '@type': 'Rating',
        ratingValue: '4.5',
      },
    },
  });

  useEffect(() => {
    document.title = '養父市ハチ高原 あさぎり荘 | スキー場近くの合宿・宿泊施設';
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HeroSection />
      <IntroductionSection />
      <CuisineSection />
      <CampSection />
      <SkiRentalSection />
      <PricingSection />
      <AccessSection />
      <CTASection />
      <Footer />
    </div>
  );
}
